import { render, staticRenderFns } from "./VExpansionText.vue?vue&type=template&id=1d65834f"
import script from "./VExpansionText.vue?vue&type=script&lang=js"
export * from "./VExpansionText.vue?vue&type=script&lang=js"
import style0 from "./VExpansionText.vue?vue&type=style&index=0&id=1d65834f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d65834f')) {
      api.createRecord('1d65834f', component.options)
    } else {
      api.reload('1d65834f', component.options)
    }
    module.hot.accept("./VExpansionText.vue?vue&type=template&id=1d65834f", function () {
      api.rerender('1d65834f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VExpansionText.vue"
export default component.exports